<h2 mat-dialog-title>Edit Loan Purpose</h2>
<mat-dialog-content class="mat-typography">
  <div class="edit-loan-purpose-dialog-content">
    @if (isLoading) {
      <div class="loading-container">
        <mat-spinner diameter="40"></mat-spinner>
        <p>Checking account status...</p>
      </div>
    } @else {
      
      <form [formGroup]="formGroup">
        <div class="form-section">
          <h3 class="section-title">Loan Purpose</h3>
          <div class="form-field-container">
            <loan-purpose-selection
              [formControl]="formControlLoanPurpose"
              [applicationType]="'BusinessOverdraft'"
              [hasActiveOverdraftAccount]="hasActiveOverdraftAccount">
            </loan-purpose-selection>
          </div>
        </div>

        @if (showTermRenewal) {
          <div class="form-section term-renewal-section">
            <div class="row">
              <div class="col-lg-6 col-md-12">
                <h3 class="section-title">Term Renewal</h3>
                <div class="form-field-container">
                  <yes-no 
                    title="Renew term for another 36 months?" 
                    [formControl]="formControlTermRenewal">
                  </yes-no>
                </div>
              </div>
          </div>
          </div>
        }
      </form>
    }
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()" [disabled]="isSaving || isLoading">Cancel</button>
  <button 
    mat-flat-button 
    color="primary" 
    (click)="onSubmit()" 
    [disabled]="!formGroup.valid || isSaving || isLoading">
    @if (isSaving) {
      <mat-spinner diameter="20" class="button-spinner"></mat-spinner>
      Saving...
    } @else {
      Save Changes
    }
  </button>
</mat-dialog-actions>
